var notification = {
  init: function() {
    $('body').on('click', '.notification-close', function(e) {
      e.preventDefault();
      $(this).closest('.notification').fadeOut(500);
    });
  },
  toast: function(msg) {
    const toast = document.createElement('div');
    toast.innerHTML = msg;
    toast.classList.add('shadow-sm');
    toast.classList.add('notification-fixed');
    toast.classList.add('show');
    document.getElementById('document').appendChild(toast);

    setTimeout(() => {
      toast.classList.remove('show');
      document.querySelectorAll('.notification-fixed').forEach(el => el.remove());
    }, 5000);
  }
};
